import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { ReportStatusEnum } from '../enums/report-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function reportStatusToColor(status: ReportStatusEnum): string {
	switch (status) {
		case ReportStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case ReportStatusEnum.ARCHIVED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
